import script from "./ContactCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactCard.vue?vue&type=script&setup=true&lang=js"

import "./ContactCard.vue?vue&type=style&index=0&id=738a822d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738a822d"]])

export default __exports__